import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const IssueLevelSecurity = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "JiraSoftwarePricingPage.content-modal.issue-level-security.header",
            defaultMessage: "Issue-level security"
        }),
        body: intl.formatMessage({
            id: "JiraSoftwarePricingPage.content-modal.issue-level-security.body",
            defaultMessage:
                "Safe for every type of sensitive work, lock down issues so only specific users or user groups can see and edit information."
        }),
        body2: intl.formatMessage(
            {
                id: "JiraSoftwarePricingPage.content-modal.issue-level-security.body2",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about issue-level security."
            },
            {
                learnMore: (chunks: React.ReactNode) => (
                    <a
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        href={`https://support.atlassian.com${useLocalizedHref(
                            "/jira-cloud-administration/docs/configure-issue-security-schemes/"
                        )}`}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraSoftware"
                    >
                        {chunks}
                    </a>
                )
            }
        )
    };
    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
            <p>{messages.body2}</p>
        </div>
    );
};

export default IssueLevelSecurity;
